import { render, staticRenderFns } from "./boxDownload.vue?vue&type=template&id=6132b0cc"
import script from "./boxDownload.vue?vue&type=script&lang=js"
export * from "./boxDownload.vue?vue&type=script&lang=js"
import style0 from "./boxDownload.vue?vue&type=style&index=0&id=6132b0cc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports